import Lesson from "./Lesson";
import MainPage from "../templatePage/templatePage";

const LessonPage = () => {
  return <MainPage component={<Lesson />} />;
};

export default LessonPage;
